import { useState } from "react";
import { Copy, Check, Tag } from "lucide-react";
import { toast } from "sonner";

export default function DiscountBadge({ label, code, slug, compact = false }) {
  const [copied, setCopied] = useState(false);
  if (!code) return null;

  const copy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard?.writeText(code).catch(() => {});
    setCopied(true);
    toast.success(`CODE ${code} COPIED`);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      onClick={copy}
      data-testid={`discount-badge-${slug}`}
      title={`Copy code ${code}`}
      className={`pulse-chip inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-pink-500 to-fuchsia-500 font-mono font-700 text-white transition-all duration-300 hover:-translate-y-0.5 ${
        compact ? "px-3 py-1.5 text-[10px]" : "px-4 py-2 text-[11px]"
      }`}
    >
      <Tag size={compact ? 11 : 12} />
      <span>{label}</span>
      <span className="text-white/90">{code}</span>
      {copied ? <Check size={12} className="text-signal" /> : <Copy size={12} className="opacity-60" />}
    </button>
  );
}
